import hexRgb from 'hex-rgb';

export const toRgba = (hex: string, alpha = 1): string => {
    return hexRgb(hex, { format: 'css', alpha });
};
